export const convertCurrencyNameToSymbol = (currencyName) => {
    switch (currencyName) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'TRY':
            return '₺';
        case 'TL':
            return '₺';
        default:
            return '';
    }
}